import { buildProps, definePropType } from '@ll-plus/utils'
import type {
  RadioGroupProps as AntRadioGroupProps,
  RadioProps as AntRadioProps,
  ColProps,
  RowProps,
} from 'ant-design-vue'
import { ExtractPropTypes } from 'vue'
import type RadioGroup from './radio-button.vue'
import type RadioButton from './radio-group.vue'
import type Radio from './radio.vue'

type option = AntRadioGroupProps & {
  colOptions?: ColProps
  label?: string
  span?: number
  icon?: string
}

const direction = ['vertical', 'horizontal'] as const
const optionType = ['default', 'button'] as const

// 单选组
export const radioGroupProps = buildProps({
  options: {
    type: definePropType<option[]>(Array),
    default: () => [],
  },

  // 是否使用栅格布局
  useGrid: {
    type: Boolean,
    default: true,
  },

  // 栅格布局配置
  rowOptions: {
    type: definePropType<RowProps>(Object),
    default: () => {},
  },

  // 栅格项水平间距
  gutterHorizontal: {
    type: Number,
    default: 8,
  },

  // 栅格项垂直间距
  gutterVertical: {
    type: Number,
    default: 8,
  },

  // 子项占位格数
  allSpan: {
    type: Number,
    default: 6,
  },

  // 排列方向
  direction: {
    type: String,
    values: direction,
    default: 'horizontal',
  },

  // 项间距
  itemSpace: {
    type: Number,
    default: 8,
  },

  // 单选器展示类型
  optionType: {
    type: String,
    default: 'default',
    values: optionType,
  },
} as const)

// props
export type RadioProps = AntRadioProps

export type RadioButtonProps = AntRadioProps

export type RadioGroupProps = ExtractPropTypes<typeof radioGroupProps>

// instance
export type RadioInstance = InstanceType<typeof Radio>

export type RadioButtonInstance = InstanceType<typeof RadioButton>

export type RadioGroupInstance = InstanceType<typeof RadioGroup>
